import 'css-chunksrc/client/pages/exportsPage/timesheetReport/filters/styles.scss';export default {
  "filters": "_filters_1sltk_1",
  "resetButton": "_resetButton_1sltk_17",
  "label": "_label_1sltk_25",
  "section": "_section_1sltk_32"
};